import { MaterialTypeEnum } from "@ns/types";

export const MaterialSelectProps = [
  {
    value: MaterialTypeEnum.GRANITE,
    label: "Granit",
  },
  {
    value: MaterialTypeEnum.MARBLE,
    label: "Mermer",
  },
  {
    value: MaterialTypeEnum.ONYX,
    label: "Oniks",
  },
  {
    value: MaterialTypeEnum.QUARTZ,
    label: "Kvarc",
  },
  {
    value: MaterialTypeEnum.TRAVERTINE,
    label: "Travertin",
  },
  {
    value: MaterialTypeEnum.QUARZITE,
    label: "Kvarcit",
  },
  {
    value: MaterialTypeEnum.PESCAR,
    label: "Pescar",
  },
  {
    value: MaterialTypeEnum.KRECNJAK,
    label: "Krecnjak",
  },
  {
    value: MaterialTypeEnum.KERAMIKA,
    label: "Keramika",
  },
];
